import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { FormInput } from 'modules';

interface AgreementInputProps {
  name: string;
  disabled?: boolean;
  checked: boolean;
  error?: string;
  onChange: (e: React.ChangeEvent) => void;
}

const AgreementInput = ({ name, disabled = false, checked, error, onChange }: AgreementInputProps) => {
  return (
    <Row>
      <Col>
        <FormInput
          type={'checkbox'}
          name={name}
          label={
            <>
              Odoslaním tohto formulára potvrdzujem, že som bol informovaný/á o{' '}
              <a
                href="https://bonato.sk/informacie-a-pristup-k-osobnym-udajom/"
                target="_blank"
                rel="noopener noreferrer"
              >
                spracúvaní mojich osobných údajov
              </a>
              .*
              <br />
              Bližšie informácie o ochrane osobných údajov nájdete{' '}
              <a
                href="https://bonato.sk/informacia-o-ochrane-osobnych-udajov-na-web-ohladom-suhlasu-so-spracuvanim-osobnych-udajov-na-marketingove-ucely-spolocnosti/"
                target="_blank"
                rel="noopener noreferrer"
              >
                TU
              </a>
              .
            </>
          }
          disabled={disabled}
          checked={checked}
          error={error}
          onChange={onChange}
        />
      </Col>
    </Row>
  );
};

export default AgreementInput;
